import type { LocaleMessageBundle } from '../../types'

export const authSplashMessages: LocaleMessageBundle = {
  vi: {
    'auth.splash.title': 'Đang khởi động BigSale',
    'auth.splash.subtitle': 'Chuẩn bị dữ liệu để sẵn sàng bán hàng...',
    'auth.splash.steps.verifying': 'Xác thực tài khoản',
    'auth.splash.steps.bootstrap': 'Tải dữ liệu bán hàng',
    'auth.splash.steps.settings': 'Tải cấu hình hệ thống',
    'auth.splash.steps.ready': 'Sẵn sàng!',
  },
  en: {
    'auth.splash.title': 'Starting BigSale',
    'auth.splash.subtitle': 'Preparing your data to start selling...',
    'auth.splash.steps.verifying': 'Verifying account',
    'auth.splash.steps.bootstrap': 'Loading sales data',
    'auth.splash.steps.settings': 'Loading system settings',
    'auth.splash.steps.ready': 'Ready!',
  },
}
